import * as z from 'zod';
import { CatCodeEnum } from './enums/catCode';
import { UrgCodeEnum } from './enums/urgCode';

const CrUrgenceiSchema = z.object({
  urg_code: z.enum(['ROU', 'URG']),
  urg_desc: z.string()
});

const CrQueueSchema = z.object({
  add_appt_id: z.number().nullable(),
  appt_id: z.number().nullable(),
  cr_queue_code: z.string(),
  urg_code: UrgCodeEnum,
  urg_desc: z.string(),
  client_id: z.number(),
  case_created_date: z.coerce.date(),
  client_name: z.string(),
  case_id: z.number(),
  client_case_id: z.string(),
  cat_code: CatCodeEnum,
  cat_desc: z.string(),
  case_spec_area_code: z.null(),
  case_spec_area: z.null(),
  patient_no_title: z.string(),
  user_guid: z.string(),
  survey_completed_date: z.coerce.date().nullable().optional()
});

const CrQueueCountSchema = z.object({
  cr_queue_code: z.string(),
  urg_code: UrgCodeEnum,
  cr_queue_desc: z.string(),
  cr_queue_label: z.string(),
  cr_queue_count: z.number(),
  cr_low_threshold: z.number(),
  cr_high_threshold: z.number()
});

export const ResponseSchema = z.object({
  cr_queue_counts: z.array(CrQueueCountSchema),
  cr_urgenceis: z.array(CrUrgenceiSchema),
  cr_queues: z.array(CrQueueSchema)
});
export type Response = z.infer<typeof ResponseSchema>;

export const ParamsSchema = z.object({
  source_url: z.string().url()
});
export type Params = z.infer<typeof ParamsSchema>;
